import { createSlice } from "@reduxjs/toolkit";
import { getDailyMessage } from "./dailyMessageService";

const initialState = {
    allDailyMessages: {
        isMessageLoading: null,
        isMessageSuccess: null,
        message: null,
        pageCount: 0,
        messages: []
    },
    newDailyMessage: {
        isMessageCreating: null,
        isMessageCreated: null,
        creationMessage: null,
    },
};

const dailyMessageSlice = createSlice({
    name: 'dailyMessage',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDailyMessage.pending, (state) => {
                console.log("daily message pending");
                state.allDailyMessages = {
                    ...initialState.allDailyMessages,
                    isMessageLoading: true,
                };
            })

            .addCase(getDailyMessage.rejected, (state, action) => {
                console.log("daily message rejected", action);
                state.allDailyMessages = {
                    ...initialState.allDailyMessages,
                    isMessageLoading: false,
                    isMessageSuccess: false,
                    message: action.payload?.message || "Error",
                };
            })

            .addCase(getDailyMessage.fulfilled, (state, action) => {
                console.log("daily message fulfilled", action);
                state.allDailyMessages = {
                    ...initialState.allDailyMessages,
                    isMessageLoading: false,
                    isMessageSuccess: true,
                    pageCount: action.payload.pageCount,
                    message: action.payload?.data || "Success",
                };

            });
    },
})
export default dailyMessageSlice.reducer;